const PUBLIC_URL = process.env.PUBLIC_URL || '';

const parseDomains = (value) =>
  (value || '')
    .split(',')
    .map((domain) => domain.trim().toLowerCase().replace(/^@/, ''))
    .filter(Boolean);

export const ORGANIZATION_BRAND = {
  name: 'Koloğlu Holding',
  portalName: 'Koloğlu Holding İntranet',
  logoPath: `${PUBLIC_URL}/kologlu.png`,
  academyUrl: process.env.REACT_APP_ACADEMY_URL || 'https://www.kologluakademi.com.tr/',
  koleaveUrl: process.env.REACT_APP_KOLEAVE_URL || 'https://koleave.kolin.com.tr/',
  peykUrl: process.env.REACT_APP_PEYK_URL || 'https://peyk.kolaysoft.com.tr/'
};

// Anasayfadaki dış uygulama kısayol kartları (KoLeave / Koloğlu Akademi / PEYK).
export const EXTERNAL_APP_LINKS = [
  {
    id: 'koleave',
    label: 'KoLeave',
    description: 'İzin ve devam yönetimi',
    url: ORGANIZATION_BRAND.koleaveUrl,
    imagePath: `${PUBLIC_URL}/koleave.png`
  },
  {
    id: 'academy',
    label: 'Koloğlu Akademi',
    description: 'Eğitim ve gelişim portalı',
    url: ORGANIZATION_BRAND.academyUrl,
    imagePath: `${PUBLIC_URL}/akademi.png`
  },
  {
    id: 'peyk',
    label: 'PEYK',
    description: 'Performans ve yetkinlik sistemi',
    url: ORGANIZATION_BRAND.peykUrl,
    imagePath: `${PUBLIC_URL}/peyk.png`
  }
];

export const DEFAULT_EMAIL_DOMAINS = ['kologlu.com.tr', 'kolin.com.tr'];

export const ALLOWED_EMAIL_DOMAINS =
  parseDomains(process.env.REACT_APP_ALLOWED_EMAIL_DOMAINS).length > 0
    ? parseDomains(process.env.REACT_APP_ALLOWED_EMAIL_DOMAINS)
    : DEFAULT_EMAIL_DOMAINS;

export const corporateEmailPlaceholder = `ad.soyad@${ALLOWED_EMAIL_DOMAINS[0]}`;

export const isAllowedCorporateEmail = (email = '') => {
  const domain = email.trim().toLowerCase().split('@')[1];
  return ALLOWED_EMAIL_DOMAINS.includes(domain);
};
